// Type imports:
import { IBookmark } from '../api/BookmarkTypes';

/* REQUEST BOOKMARKS */
export const REQUEST_BOOKMARKS_WAITING = 'REQUEST_BOOKMARKS_WAITING';
export const REQUEST_BOOKMARKS_SUCCESS = 'REQUEST_BOOKMARKS_SUCCESS';
export const REQUEST_BOOKMARKS_FAILURE = 'REQUEST_BOOKMARKS_FAILURE';

interface IRequestBookmarksWaitingAction {
    type: typeof REQUEST_BOOKMARKS_WAITING,
}

interface IRequestBookmarksSuccessAction {
    type: typeof REQUEST_BOOKMARKS_SUCCESS,
    payload: {
        bookmarks: Array<IBookmark>
    }
}

interface IRequestBookmarksFailureAction {
    type: typeof REQUEST_BOOKMARKS_FAILURE,
    payload: {
        error: string
    }
}

/* ADD BOOKMARK */
export const ADD_BOOKMARK_SUCCESS = 'ADD_BOOKMARK_SUCCESS';
export const ADD_BOOKMARK_FAILURE = 'ADD_BOOKMARK_FAILURE';

interface IAddBookmarkSuccessAction {
    type: typeof ADD_BOOKMARK_SUCCESS,
    payload: {
        bookmark: IBookmark
    }
}

interface IAddBookmarkFailureAction {
    type: typeof ADD_BOOKMARK_FAILURE,
    payload: {
        error: string
    }
}

/* EDIT BOOKMARK */
export const EDIT_BOOKMARK_SUCCESS = 'EDIT_BOOKMARK_SUCCESS';
export const EDIT_BOOKMARK_FAILURE = 'EDIT_BOOKMARK_FAILURE';

interface IEditBookmarkSuccessAction {
    type: typeof EDIT_BOOKMARK_SUCCESS,
    payload: {
        bookmark: IBookmark
    }
}

interface IEditBookmarkFailureAction {
    type: typeof EDIT_BOOKMARK_FAILURE,
    payload: {
        error: string
    }
}


/* DELETE BOOKMARK */
export const DELETE_BOOKMARK_SUCCESS = 'DELETE_BOOKMARK_SUCCESS';
export const DELETE_BOOKMARK_FAILURE = 'DELETE_BOOKMARK_FAILURE';

interface IDeleteBookmarkSuccessAction {
    type: typeof DELETE_BOOKMARK_SUCCESS,
    payload: {
        bookmark: IBookmark
    }
}

interface IDeleteBookmarkFailureAction {
    type: typeof DELETE_BOOKMARK_FAILURE,
    payload: {
        error: string
    }
}


/* EXPORT */
export type BookmarkActions =
// Request bookmarks.
IRequestBookmarksWaitingAction
| IRequestBookmarksSuccessAction
| IRequestBookmarksFailureAction
// Add bookmark.
| IAddBookmarkSuccessAction
| IAddBookmarkFailureAction
// Edit bookmark.
| IEditBookmarkSuccessAction
| IEditBookmarkFailureAction
// Delete bookmark
| IDeleteBookmarkSuccessAction
| IDeleteBookmarkFailureAction;